/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![HomeIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAABg0lEQVR4nNWVPUoDQRTHV0VsbAU/wEb0FBYpLNZk38eK43uLhd0eQMGU8QqieAfxBhaKioKVrR7AxkKITVCMyoQkKruzm2xS6MAflmHm95t5M8N63l9pvu9PAOuWjf0eKjwIzDyQ3CLrpw2w3DHLwlDgwBIgy3MH/h2pI+p6YbAxZgxI9oCkmYR38wEk+3Ecj/cF942ZQpLTDPCvAOtFGG7O9AQPOFoGlsde4dgJ6RPixkomHFhiIHnrG87tnZC+27LWarXRRL2R5LgoGBMlkxPL7AqIIhgWHNshiso/6i6rwxZAqH5XYGsGJIdI0hgYTtJA0gPP80aSh0y6M/jqZTvjFmnkuB2vQLqLqLM2QFK1fY43ETkFRFJKF0g1uVupph+ulJwCZllKmxSmvNKyMdNpYytr0aJTYIyZTJvkOVraWMtwClpbZ30pLpB6JrwlIH0oKgDW+3wB6/kAgrNcAZIeFRaQHOYKKhUzhyQ3nR8NsF66FyNXbXATWK/tG8kV/Lv2BZ9HE3cbKXSfAAAAAElFTkSuQmCC)
 */
export const HomeIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="m2.4 8.4 8.38-6.46a2 2 0 0 1 2.44 0l8.39 6.45a2 2 0 0 1-.79 3.54l-.32.07-.82 8.2a2 2 0 0 1-1.99 1.8H16a1 1 0 0 1-1-1v-5a3 3 0 1 0-6 0v5a1 1 0 0 1-1 1H6.31a2 2 0 0 1-1.99-1.8L3.5 12l-.32-.07a2 2 0 0 1-.79-3.54Z"
        className={colorClass}
      />
    </svg>
  );
};
